import { atom } from 'jotai'
import { ChallengeService } from '@duck/api-definitions'

// --- Solution handlers (for tab-based Solution component; set by Workspace) ---
export const workspaceSolutionHandlersAtom = atom<{
  handleSolutionChange: (solution: string) => void
  handleChartAdded: (solution: string, chart: ChallengeService.Chart) => void
  handleChartRemoved: (solution: string, remainingChartIds: string[]) => void
} | null>(null)

// --- Workspace loaded data (for new components; WorkspaceParent still passes props for backward compat) ---
export const workspaceChallengeIdAtom = atom<string | null>(null)
export const workspaceChallengeAtom = atom<ChallengeService.ChallengeInfo['challenge'] | null>(null)
export const workspaceTaskAtom = atom<ChallengeService.ChallengeInfo['task'] | null>(null)
export const workspaceChartsAtom = atom<ChallengeService.WorkState['charts'] | null>(null)
export const workspaceErrorAtom = atom<ChallengeService.ChallengeErrorCode | null>(null)
export const workspaceIsVisibleAtom = atom<boolean>(false)
export const workspaceDisclaimerDialogOpenAtom = atom<boolean>(false)

// Partner's submit message returned by the submit request, handed to the completed page so it opens the
// dialog with what the server just resolved (no list fetch needed). In-memory only: a refresh drops it.
export type PostSubmitMessage = { challengeId: string; organizationId?: string; message: string }
export const postSubmitMessageAtom = atom<PostSubmitMessage | null>(null)

// --- WorkspaceTabs view count (tracks if there are two views) ---
export const workspaceTabsHasTwoViewsAtom = atom<boolean>(false)

// --- Solution review (pre-submit) visibility ---
export const workspaceSolutionReviewVisibleAtom = atom<boolean>(false)

// --- Recent tips from user progress ---
export const workspaceRecentTipsAtom = atom<ChallengeService.RecentTipsEntry[]>([])

// --- Table metadata (row/size counts per table, fetched once per workspace load) ---
export const workspaceTableMetadataAtom = atom<Record<string, ChallengeService.TableMetadataEntry> | null>(null)

// --- Workspace Settings dialog open state ---
export const workspaceSettingsOpenAtom = atom<boolean>(false)
// One-shot override: set alongside opening the dialog to land on a specific
// tab. The dialog reads + clears it on open so subsequent opens reset to the
// default tab. Kept as a string literal union (rather than importing the nav
// key type) to avoid a store → component dependency.
export const workspaceSettingsInitialTabAtom = atom<
  'challenge' | 'appearance' | 'behavior' | 'python' | 'shortcuts' | null
>(null)

// --- Pending weapon pick (drives the PickWeaponDialog before boot) ---
export type PendingWeaponPick = {
  taskId: string
  allowedWeapons: ChallengeService.TaskWeaponsOfChoiceEnum[]
  onPicked: (weapon: ChallengeService.TaskWeaponsOfChoiceEnum) => void
  onCancelled: () => void
}
export const pendingWeaponPickAtom = atom<PendingWeaponPick | null>(null)

